<div class="page-content anpp" id="content">

    @if (hasResult) {
        <div class="row tableau">

            <div class="col-lg-12">
                <div class="cards  border-radius-onglet text-center" style="background:#fff; display: inline-table; min-width: 100%;">
                    @if (isAnpp()) {
                        <div class="row">
                            <div class="col-lg-4"></div>
                            <div class="col-lg-1 text-start mt-4 lienMain"><label class="form-label">Groupement : </label></div>
                            <div class="col-lg-3 text-start mt-4 lienMain">
                                <select id="groupement" [ngModel]="selectedGroupementId" class="form-select" (change)="selectGroupement($event)">
                                    <option [value]="" ></option>
                                    @for (groupement of listGroupement; track groupement.id) {
                                        <option [value]="groupement.id">
                                            {{ groupement.raisonSociale }}
                                        </option>
                                    }
                                </select>
                            </div>
                            <div class="col-lg-4"></div>
                        </div>
                    }

                    <div class="row">
                        <!-- Lien filtrer -->
                        <div class="col-lg-3 text-start mt-4 lienMain">
                            <a class="ps-4" (click)="showFilter()" translate><fa-icon icon="filter"></fa-icon> label.filtrer</a>
                        </div>
                        <div class="col-lg-3 text-center">
                            <div class="pt-2 m-2 pourcentage-cadre">
                                <a href="" placement="bottom" [ngbTooltip]="'page.suivi.suivi-inventaire.pourcent-mis-a-jour-aide' | translate">
                  <span class="pourcentage"><b>{{ pourcentMisAJour|number: '1.2-2' }} %</b><br />
                    <small class="pourcentage-label">{{'page.suivi.suivi-inventaire.pourcent-mis-a-jour' | translate}}&nbsp;<fa-icon icon="info-circle"></fa-icon></small>
                  </span>
                                </a>
                            </div>
                        </div>

                        <div class="col-lg-3 text-center">
                            <div class="pt-2 m-2 pourcentage-cadre">
                                <a href="" placement="bottom" [ngbTooltip]="'page.suivi.suivi-inventaire.pourcent-valides-aide' | translate">
                <span class="pourcentage"><b>{{ pourcentValides|number: '1.2-2' }} %</b><br />
                  <small class="pourcentage-label">{{'page.suivi.suivi-inventaire.valides' | translate}}&nbsp;<fa-icon icon="info-circle"></fa-icon>
                  </small>
                </span>
                                </a>
                            </div>
                        </div>

                        <div class="col-lg text-end pt-2 pe-4">
                            <fa-icon icon="upload" class="clickable-icon" style="font-size:25px" (click)="exporterSuivis()"></fa-icon>
                        </div>

                    </div>

                    <div class="pb-2">
                        <span class="badge badge-grey">{{'page.suivi.suivi-inventaire.total-nb-entreprise'|translate}} : {{totalNbEntreprises}}</span>
                        &nbsp;
                        <span class="badge badge-grey">{{'page.suivi.suivi-inventaire.total-surf-pomme'|translate}} : {{totalSurfacePomme | number: '1.3-3'}}</span>
                        &nbsp;
                        <span class="badge badge-grey">{{'page.suivi.suivi-inventaire.total-surf-poire'|translate}} : {{totalSurfacePoire | number: '1.3-3'}}</span>
                    </div>
                    <div class="tableScroll">
                        <table class="table table-striped" aria-label="Liste des inventaires de vergers">
                            <thead class="sticky-top">
                            <tr>
                                <th scope="col">
                                    <div class="form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            id="relance"
                                            name="relance"
                                            (change)="onCheckAllDeclarations($event)"
                                        />
                                        <label class="form-check-label" for="relance"></label>
                                    </div>
                                </th>
                                <th scope="col" href="#" translate>page.suivi.suivi-inventaire.headers.operations</th>
                                <th scope="col"><div translate>page.suivi.suivi-inventaire.headers.raison-sociale</div>
                                    @if (!filtrer) {
                                        <div>
                                            <input type="text" [id]="'raisonSociale'" class="form-control bar1" [(ngModel)]="raisonSocialeFilter" (keyup)="filter()">
                                        </div>
                                    }
                                </th>
                                <th scope="col" sortable="surfacePomme" (sort)="onSort($event)"><div translate>page.suivi.suivi-inventaire.headers.surf-pommes</div>
                                    @if (!filtrer) {
                                        <div>
                                            <input type="number" [id]="'surfacePomme'" class="form-control bar1" [(ngModel)]="surfacePommeFilter" (change)="filter()">
                                        </div>
                                    }
                                </th>
                                <th scope="col" sortable="surfacePoire" (sort)="onSort($event)"><div translate>page.suivi.suivi-inventaire.headers.surf-poires</div>
                                    @if (!filtrer) {
                                        <div>
                                            <input type="number" [id]="'surfacePoire'" class="form-control bar1" [(ngModel)]="surfacePoireFilter" (change)="filter()">
                                        </div>
                                    }
                                </th>
                                <th scope="col" ><div translate>page.suivi.suivi-inventaire.headers.type</div>
                                    @if (!filtrer) {
                                        <div>
                                            <select id="sousType" [(ngModel)]="sousTypeFilter" (change)="filter()" class="form-select bar1">
                                                <option [ngValue]="null"></option>
                                                @for (type of sousTypesEntreprise; track type.id) {
                                                    <option [ngValue]="type">{{type.libelle}}</option>
                                                }
                                            </select>
                                        </div>
                                    }
                                </th>



                                <th scope="col" style="position:relative">
                                    <fa-icon icon="calendar"></fa-icon>&nbsp;<span translate>page.suivi.suivi-inventaire.headers.maj</span>
                                    @if (!filtrer) {
                                        <div>
                                            <input type="date" [id]="'dateMaj'" class="form-control bar1" [(ngModel)]="dateMajFilter" (change)="filter()">
                                        </div>
                                    }
                                </th>
                                <th scope="col">
                                    <fa-icon icon="calendar"></fa-icon>&nbsp;<span translate>page.suivi.suivi-inventaire.headers.valider</span>
                                    @if (!filtrer) {
                                        <div>
                                            <input type="date" [id]="'dateValidation'" class="form-control bar1" [(ngModel)]="dateValidationFilter" (change)="filter()">
                                        </div>
                                    }
                                </th>
                                <th scope="col" translate>page.suivi.suivi-inventaire.headers.acteur
                                    @if (!filtrer) {
                                        <div>
                                            <input type="text" [id]="'acteur'" class="form-control bar1" [(ngModel)]="acteurFilter" (change)="filter()">
                                        </div>
                                    }
                                </th>


                                @if (show('anpp')) {
                                    <th scope="col" translate>page.suivi.suivi-inventaire.headers.adherent
                                        @if (!filtrer) {
                                            <select [id]="'estadherent'" class="form-select bar1" [(ngModel)]="estadherentFilter"
                                                    (change)="filter()">
                                                <option [ngValue]="undefined"></option>
                                                <option [ngValue]="true" translate>label.oui</option>
                                                <option [ngValue]="false" translate>label.non</option>
                                            </select>
                                        }
                                    </th>
                                }
                                @if (show('terroir')) {
                                    <th scope="col" translate>page.suivi.suivi-inventaire.headers.terroir
                                        <!-- filtre terroir -->
                                        @if (!filtrer) {
                                            <select class="form-select bar1" (change)="filter()"  [(ngModel)]="terroirFilter">
                                                <option [ngValue]="undefined"></option>
                                                @for (terroir of references.terroirs; track terroir.id) {
                                                    <option [ngValue]="terroir">
                                                        {{ terroir.libelle }}
                                                    </option>
                                                }
                                            </select>
                                        }
                                    </th>
                                }
                                @if (show('departement')) {
                                    <th scope="col" translate>page.suivi.suivi-inventaire.headers.departement
                                        @if (!filtrer) {
                                            <div>
                                                <input type="text" [id]="'departement'" class="form-control bar1" [(ngModel)]="departementFilter" (change)="filter()">
                                            </div>
                                        }
                                    </th>
                                }
                                @if (show('ville')) {
                                    <th scope="col" translate>page.suivi.suivi-inventaire.headers.ville
                                        @if (!filtrer) {
                                            <div>
                                                <input type="text" [id]="'ville'" class="form-control bar1" [(ngModel)]="villeFilter" (change)="filter()">
                                            </div>
                                        }
                                    </th>
                                }
                                @if (show('valide')) {
                                    <th scope="col" translate>page.suivi.suivi-inventaire.headers.inventaire-valide
                                        @if (!filtrer) {
                                            <select [id]="'estValide'" class="form-select bar1" [(ngModel)]="estValideFilter"
                                                    (change)="filter()">
                                                <option [ngValue]="undefined"></option>
                                                <option [ngValue]="true" translate>label.oui</option>
                                                <option [ngValue]="false" translate>label.non</option>
                                            </select>
                                        }
                                    </th>
                                }
                                @if (show('ct')) {
                                    <th scope="col" translate>page.suivi.suivi-inventaire.headers.ct
                                        @if (!filtrer) {
                                            <div>
                                                <select [id]="'ct'" class="form-select bar1" [(ngModel)]="ctFilter"
                                                        (change)="filter()">
                                                    <option [ngValue]="undefined"></option>
                                                    @for (user of acteurs; track user.id) {
                                                        <option [ngValue]="user">{{user?.nom}} {{user?.prenom}}</option>
                                                    }
                                                </select>
                                            </div>
                                        }
                                    </th>
                                }
                                <th>
                                    <fa-icon class="clickable-icon" icon="ellipsis-h" (click)="afficherListe()"></fa-icon>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                @if (suivisFilter.length === 0) {
                                    <tr>
                                        <td colspan="99" class="p-4 text-center"><fa-icon icon="exclamation"></fa-icon>&nbsp;
                                            <span translate>page.suivi.suivi-inventaire.no-data</span>
                                        </td>
                                    </tr>
                                }
                                @for (suivi of suivisFilter; track $index) {
                                    <tr [ngClass]="{'suivi-valide' : suivi.dateDerniereValidation}">
                                        <td>
                                            <div class="form-check" style = "z-index:0">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    id="relance-{{ $index }}"
                                                    name="relance-{{ $index }}"
                                                    [checked]="suivi.estCochee"
                                                    (change)="onCheckDeclaration($event, suivi)"
                                                />
                                                <label class="form-check-label" for="relance-{{ $index }}"></label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="btn-group">
                                                <div ngbDropdown placement="end-top">
                                                    <button class="btn btn-secondary dropdown-toggle btnprimary btn-sm "
                                                            id="dropdownConfig" ngbDropdownToggle>
                                                        <fa-icon icon="cog"></fa-icon>
                                                    </button>
                                                    <div ngbDropdownMenu aria-labelledby="dropdownConfig">
                                                        <button (click)="getEmails(suivi)" ngbDropdownItem translate
                                                                class="dropdown-item">
                                                            <fa-icon icon="user"></fa-icon>
                                                            page.suivi.suivi-inventaire.action-exporter-email
                                                        </button>
                                                        <div class="dropdown-divider"></div>
                                                        <button (click)="ficheEntreprise(suivi.idEntreprise)" ngbDropdownItem translate
                                                                class="dropdown-item">
                                                            <fa-icon icon="id-card"></fa-icon>
                                                            page.suivi.suivi-inventaire.action-fiche-entreprise
                                                        </button>
                                                        <div class="dropdown-divider"></div>
                                                        <button (click)="inventaireVerger(suivi)" ngbDropdownItem translate
                                                                class="dropdown-item">
                                                            <fa-icon icon="file-alt"></fa-icon>
                                                            page.suivi.suivi-inventaire.action-inventaire-verger
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{{suivi.entreprise ? suivi.entreprise.raisonSociale : '-'}}</td>
                                        <td>{{suivi.surfacePomme | number: '1.3-3'}}</td>
                                        <td>{{suivi.surfacePoire | number: '1.3-3'}}</td>
                                        <td>{{suivi.entreprise && suivi.entreprise.refSousType ? suivi.entreprise.refSousType.libelle : '-'}}</td>
                                        <td>{{suivi.dateDerniereMaj | date:'dd/MM/yyyy' }}</td>
                                        <td>{{suivi.dateDerniereValidation | date:'dd/MM/yyyy' }} </td>
                                        <td>{{suivi.auteurModification?.prenom}} {{suivi.auteurModification?.nom}}</td>
                                        <!-- optionnel-->
                                        @if (show('anpp')) {
                                            <td><input type="checkbox" [checked]="suivi.entreprise?.estAdherent" [disabled]="true" /></td>
                                        }
                                        @if (show('terroir')) {
                                            <td>{{getTerroir(suivi)}}</td>
                                        }
                                        @if (show('departement')) {
                                            <td>{{suivi.entreprise ? suivi.entreprise.departement : '-'}}</td>
                                        }
                                        @if (show('ville')) {
                                            <td>{{suivi.entreprise ? suivi.entreprise.commune : '-'}}</td>
                                        }
                                        @if (show('valide')) {
                                            <td><input type="checkbox" [checked]="suivi.dateDerniereValidation" [disabled]="true" /></td>
                                        }
                                        @if (show('ct')) {
                                            <td>{{suivi.ct}}</td>
                                        }
                                        <td></td>

                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    }
  <div  class="btn-relance">
    <div class="row">
      <div class="col-lg-8 pt-2 pb-2">
        <div class="btn-group dropdown">
          <div ngbDropdown placement="top-start">
            <button class="btn  btn-secondary dropdown-toggle btnprimary" type="button" id="dropdownMenuButton" translate
              data-bs-toggle="dropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="true">
              <fa-icon icon="cogs"></fa-icon>
              page.suivi.suivi-inventaire.operations-groupes
            </button>

            <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
              @if (!estGP && !estCT) {
                <button type="button" class="dropdown-item" ngbDropdownItem (click)="relancerInventaires()" translate>
                  <fa-icon icon="envelope"></fa-icon> {{ 'page.suivi.suivi-inventaire.action-relancer' | translate }}
                </button>
                <div class="dropdown-divider"></div>
              }

              <button (click)="exporterInventaires()" ngbDropdownItem translate
                      class="dropdown-item">
                <fa-icon icon="upload" style="margin-right: 5px;"></fa-icon>page.suivi.suivi-inventaire.action-exporter-csv
              </button>
              <div class="dropdown-divider"></div>
              <button (click)="exporterSynthesePdf()" ngbDropdownItem translate
                      class="dropdown-item">
                <fa-icon icon="upload" style="margin-right: 5px;"></fa-icon>page.suivi.suivi-inventaire.action-exporter-pdf
              </button>
              <div class="dropdown-divider"></div>

              <button (click)="validerInventaires()" ngbDropdownItem translate
                      class="dropdown-item">
                <fa-icon icon="check" style="margin-right: 5px;"></fa-icon>page.suivi.suivi-inventaire.action-valider
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


